import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Quote, Instagram, Youtube, Facebook, Linkedin } from 'lucide-react';
import AltHeader from '../components/AltHeader';
import AltFooter from '../components/AltFooter';
import AltParallaxBackdrop from '../components/AltParallaxBackdrop';

/* Brand glyphs that lucide-react doesn't ship a built-in icon for. */
const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);
const BlueskyIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.056-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 0 1-.415-.056c.14.017.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8z"/>
  </svg>
);
const ThreadsIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M12.18 24h-.07C8.32 23.97 5.41 22.79 3.5 20.49c-1.7-2.04-2.58-4.88-2.61-8.43v-.13c.03-3.55.91-6.39 2.61-8.43C5.41 1.21 8.32.03 12.11 0h.07c2.91.02 5.34.7 7.21 2.04 1.76 1.26 3 3.05 3.69 5.31l-2.21.66c-1.17-3.83-3.86-5.78-8.7-5.81-3.18.02-5.59.97-7.16 2.83-1.47 1.74-2.23 4.26-2.26 7.47.03 3.21.79 5.73 2.26 7.47 1.57 1.86 3.98 2.81 7.16 2.83 2.86-.02 4.76-.7 6.34-2.27 1.79-1.79 1.76-3.98 1.18-5.31-.34-.78-.96-1.43-1.79-1.91-.21 1.49-.68 2.7-1.42 3.61-.99 1.21-2.4 1.87-4.18 1.96-1.36.07-2.66-.25-3.68-.91-1.19-.78-1.89-1.97-1.96-3.36-.07-1.36.47-2.62 1.51-3.55 1-.89 2.39-1.41 4.04-1.5.91-.05 1.76 0 2.55.13-.1-.65-.31-1.16-.62-1.53-.42-.51-1.07-.77-1.94-.78-.74 0-1.74.21-2.38 1.16l-1.95-1.31c.85-1.27 2.24-1.96 4.34-1.96 1.7 0 3.04.55 3.99 1.65.83.96 1.27 2.27 1.31 3.91.62.27 1.16.59 1.6.95 1.43 1.16 2.21 2.85 2.21 4.81 0 1.74-.7 3.4-2.05 4.79-1.58 1.62-3.74 2.43-6.56 2.43z"/>
  </svg>
);
const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413"/>
  </svg>
);

const SOCIAL_LINKS = [
  { url: 'https://www.instagram.com/brokebillionr', label: 'Instagram', Icon: Instagram },
  { url: 'https://www.facebook.com/levkazaryan.personal', label: 'Facebook', Icon: Facebook },
  { url: 'https://www.youtube.com/@Brokebillionr', label: 'YouTube', Icon: Youtube },
  { url: 'https://x.com/BrokeBillionr', label: 'X', Icon: XIcon },
  { url: 'https://www.linkedin.com/in/levkazaryan/', label: 'LinkedIn', Icon: Linkedin },
  { url: 'https://www.threads.com/@brokebillionr', label: 'Threads', Icon: ThreadsIcon },
  { url: 'https://bsky.app/profile/brokebillionr.bsky.social', label: 'Bluesky', Icon: BlueskyIcon },
  { url: 'https://whatsapp.com/channel/0029Vb838jD05MUcNmflUa2i', label: 'WhatsApp Channel', Icon: WhatsAppIcon },
];

/* Chapter — opinionated section block (same component shape as
   LevantaStory's chapter blocks for visual consistency). */
const Chapter = ({ eyebrow, title, italic, children, dataTestId }) => (
  <section className="px-6 pt-8 pb-12 md:py-24" data-testid={dataTestId}>
    <div className="max-w-5xl mx-auto grid md:grid-cols-12 gap-x-10 gap-y-8">
      <div className="md:col-span-4">
        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-blue-600 mb-4">
          {eyebrow}
        </p>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-black leading-[1.05] tracking-tight text-[#0b1f3a]">
          {title}{' '}
          {italic && <em className="italic font-light text-blue-600">{italic}</em>}
        </h2>
      </div>
      <div className="md:col-span-7 md:col-start-6 space-y-5 text-[17px] md:text-lg leading-relaxed text-[#0b1f3a]/80">
        {children}
      </div>
    </div>
  </section>
);

const Founder = () => {
  return (
    <div className="bg-white overflow-x-hidden">
      <AltHeader />

      {/* HERO — split portrait + manifesto card. Same sky gradient as the
          rest of the site so the transparent header has a colored backdrop. */}
      <section className="relative pt-[110px] md:pt-[170px] pb-14 md:pb-24 px-6 overflow-hidden min-h-[580px] md:min-h-[760px]">
        <AltParallaxBackdrop />

        <div className="relative z-10 max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span
              className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-[#0b1f3a]/80 backdrop-blur-md text-xs md:text-[13px] font-semibold tracking-[0.18em] uppercase text-white shadow-lg ring-1 ring-white/20 mb-7"
              data-testid="founder-eyebrow"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-cyan-300 inline-block" />
              About the founder
            </span>
            <h1
              className="text-4xl md:text-7xl font-black leading-[1.02] tracking-tight text-[#0b1f3a] alt-hero-glow"
              >
              Lev <em className="italic font-light text-blue-600">Kazaryan.</em>
            </h1>
          </div>

          {/* Portrait + manifesto card */}
          <div className="grid md:grid-cols-2 gap-6 md:gap-8 items-center">
            <div className="relative flex items-center justify-center">
              <img
                src="https://customer-assets.emergentagent.com/job_levanta-preview/artifacts/zkw3avpa_Screenshot_2024-10-30-10-30-26-38_1c337646f29875672b5a61192b9010f9.jpg"
                alt="Lev Kazaryan, founder of Levanta"
                width="800"
                height="1000"
                loading="lazy"
                className="rounded-3xl w-[85%] h-auto object-cover shadow-2xl ring-1 ring-black/5"
              />
            </div>
            <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-8 md:p-10 ring-1 ring-black/5 shadow-xl">
              <Quote className="w-9 h-9 text-blue-300 mb-4" strokeWidth={2} aria-hidden="true" />
              <p className="text-2xl md:text-3xl font-bold text-[#0b1f3a] leading-snug">
                I didn&rsquo;t build Levanta because I had{' '}
                <em className="italic font-light text-blue-600">the answers.</em>{' '}
                I built it because I had to{' '}
                <em className="italic font-light text-blue-600">find them.</em>
              </p>
              <p className="mt-6 text-sm uppercase tracking-[0.2em] text-blue-600 font-semibold">
                — Lev Kazaryan
              </p>

              {/* Social row */}
              <div className="mt-8 pt-6 border-t border-black/5">
                <p className="text-[11px] tracking-[0.22em] uppercase text-[#0b1f3a]/55 font-semibold mb-3">
                  Follow Lev personally
                </p>
                <div
                  className="flex flex-wrap gap-2.5"
                  data-testid="founder-social-links"
                >
                  {SOCIAL_LINKS.map(({ url, label, Icon }) => (
                    <a
                      key={label}
                      href={url}
                      target="_blank"
                      rel="me noopener noreferrer"
                      aria-label={`Lev Kazaryan on ${label}`}
                      title={label}
                      data-testid={`founder-social-${label.toLowerCase()}`}
                      className="w-10 h-10 rounded-full bg-[#f4f8fc] text-[#0b1f3a] hover:bg-blue-600 hover:text-white hover:-translate-y-0.5 hover:shadow-lg flex items-center justify-center transition-all duration-200"
                    >
                      <Icon className="w-4 h-4" />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OPENING line — sets the tone in one breath. Tighter vertical
          padding on mobile so the gap between this one-liner and the
          first Chapter below doesn't feel like a missing section. */}
      <section className="px-6 pt-12 pb-10 md:py-28 bg-white">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-2xl md:text-5xl font-black leading-[1.15] tracking-tight text-[#0b1f3a]">
            I wasn&rsquo;t born confident.{' '}
            <em className="italic font-light text-blue-600">I had to build it.</em>
          </p>
        </div>
      </section>

      {/* Chapter 01 — the invisible kid */}
      <Chapter
        eyebrow="Chapter 01"
        title="Quiet. Invisible."
        italic="Unwanted by myself."
        dataTestId="founder-chapter-1"
      >
        <p>
          As a child I was quiet, introverted, and invisible. I sat at the back of
          the classroom and no one noticed I was there. I didn&rsquo;t really have
          friends. I felt like no one liked me.
        </p>
        <p className="font-semibold text-[#0b1f3a]">
          The truth is, I didn&rsquo;t like myself either.
        </p>
        <div className="space-y-1 text-[#0b1f3a]/70 italic">
          <p>I didn&rsquo;t like how I looked.</p>
          <p>I didn&rsquo;t like how I sounded.</p>
          <p>I didn&rsquo;t like who I was.</p>
        </div>
        <p>
          And at the same time, I wanted attention. I wanted to be seen. I wanted
          to matter.
        </p>
        <p>
          So I kept changing my appearance — growing my hair, eventually covering
          my face with piercings — hoping it would finally make me visible.
        </p>
      </Chapter>

      {/* Pull-quote — the painful realization. */}
      <section className="px-6 py-16 md:py-20 bg-[#f4f8fc]">
        <div className="max-w-4xl mx-auto relative">
          <Quote
            className="absolute -top-6 -left-2 md:-top-14 md:-left-10 w-12 h-12 md:w-28 md:h-28 text-blue-300/15 -scale-x-100"
            strokeWidth={1.5}
            aria-hidden="true"
          />
          <p className="relative text-2xl md:text-4xl font-semibold leading-snug text-[#0b1f3a]">
            People did start noticing me.{' '}
            <em className="italic font-light text-blue-600">
              But it wasn&rsquo;t the attention I was looking for.
            </em>
          </p>
          <p className="relative mt-6 text-[#0b1f3a]/70 text-base md:text-lg leading-relaxed">
            I was bullied. Mocked. Threatened. Humiliated. I had visibility — but
            not respect.
          </p>
          <p className="relative mt-5 text-sm uppercase tracking-[0.2em] text-blue-600 font-semibold">
            That was the moment I understood something had to change.
          </p>
        </div>
      </section>

      {/* Chapter 02 — the small shift. */}
      <Chapter
        eyebrow="Chapter 02"
        title="Not the world."
        italic="Me."
        dataTestId="founder-chapter-2"
      >
        <p>
          I removed the piercings. I cut my hair. And instead of walking with my
          head down, I started walking upright, looking straight ahead.
        </p>
        <p className="font-semibold text-[#0b1f3a]">
          Almost immediately, something shifted.
        </p>
        <p>
          People treated me differently. They felt more comfortable speaking with
          me. The energy around me changed.
        </p>
        <p className="font-semibold text-[#0b1f3a]">And the surprising part?</p>
        <p>
          I was still the same person. Same personality. Same thoughts. Same
          interests. But a small external shift — posture, presentation,
          self-respect — changed how the world responded to me.
        </p>
        <p className="text-[#0b1f3a] italic">
          If something this small could create change, what else could?
        </p>
      </Chapter>

      {/* The running metaphor — split tile with anecdote. */}
      <section className="px-6 py-20 md:py-24 bg-gradient-to-b from-white to-[#eaf3fb]">
        <div className="max-w-5xl mx-auto">
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-blue-600 mb-4 text-center">
            Chapter 03
          </p>
          <h2 className="text-3xl md:text-5xl font-black leading-[1.05] tracking-tight text-[#0b1f3a] text-center mb-12">
            What running{' '}
            <em className="italic font-light text-blue-600">taught me about growth.</em>
          </h2>

          <div className="grid md:grid-cols-2 gap-6">
            {/* Wrong way */}
            <div className="rounded-3xl bg-white p-7 md:p-8 ring-1 ring-black/5 shadow-sm">
              <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-rose-500 mb-3">
                The wrong way
              </p>
              <p className="text-xl md:text-2xl font-bold text-[#0b1f3a] mb-3 leading-snug">
                All in. Five kilometers. Day one.
              </p>
              <p className="text-[#0b1f3a]/75 leading-relaxed">
                I went all in, expecting big results fast. I pushed myself to five
                kilometers on the first day. I could do it — but the next day my
                body hurt, the results weren&rsquo;t visible, and I quit.
              </p>
            </div>

            {/* Right way */}
            <div className="rounded-3xl bg-[#0b1f3a] text-white p-7 md:p-8 shadow-xl">
              <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-blue-300 mb-3">
                The right way
              </p>
              <p className="text-xl md:text-2xl font-bold mb-3 leading-snug">
                Months later, I tried{' '}
                <em className="italic font-light text-blue-300">differently.</em>
              </p>
              <ol className="space-y-2.5 text-white/85 leading-relaxed">
                <li className="flex items-baseline gap-3">
                  <span className="text-blue-300 font-mono text-xs">01</span>
                  <span>Placed my sports clothes where I could see them.</span>
                </li>
                <li className="flex items-baseline gap-3">
                  <span className="text-blue-300 font-mono text-xs">02</span>
                  <span>The next day, I wore them.</span>
                </li>
                <li className="flex items-baseline gap-3">
                  <span className="text-blue-300 font-mono text-xs">03</span>
                  <span>Then I ran 500 meters. Almost ridiculous. But easy. And I did it.</span>
                </li>
                <li className="flex items-baseline gap-3">
                  <span className="text-blue-300 font-mono text-xs">04</span>
                  <span>Then 1 km. Then 1.5. Then 2. Each step slightly bigger.</span>
                </li>
              </ol>
            </div>
          </div>

          {/* Outcome — mobile font reduced so it doesn't break into the
              awkward 4-line wrap visible on phone screens. */}
          <p className="mt-10 md:mt-12 text-center text-lg md:text-3xl font-bold text-[#0b1f3a] leading-snug">
            Eventually, I ran{' '}
            <em className="italic font-light text-blue-600">15 kilometers.</em>{' '}
            It didn&rsquo;t feel impossible.{' '}
            <span className="block mt-1.5 md:mt-2">It felt earned.</span>
          </p>
        </div>
      </section>

      {/* The thesis — three-line manifesto on dark navy. */}
      <section className="px-6 py-20 md:py-28 bg-[#0b1f3a] text-white">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-blue-300 mb-6">
            That experience reinforced something powerful
          </p>
          {/* Mobile font reduced so the manifesto doesn't break into 6+
              lines on a phone screen. Desktop keeps the cinematic 5xl. */}
          <div className="space-y-4 text-2xl md:text-5xl font-black leading-tight tracking-tight">
            <p>
              Growth is not intensity.{' '}
              <em className="italic font-light text-blue-300">It is progression.</em>
            </p>
            <p>
              Not emotion.{' '}
              <em className="italic font-light text-blue-300">Structure.</em>
            </p>
          </div>
        </div>
      </section>

      {/* Chapter 04 — why Levanta exists. */}
      <Chapter
        eyebrow="Chapter 04"
        title="That is why Levanta"
        italic="exists."
        dataTestId="founder-chapter-4"
      >
        <p>
          Personal development helped me transform from insecure and invisible to
          structured and confident — but only when I stopped chasing inspiration
          and started building systems.
        </p>
        <p>
          Over nearly ten years my life changed completely — in relationships, in
          career, in identity.
        </p>
        <p>Most people don&rsquo;t fail due to lack of potential.</p>
        <p className="font-semibold text-[#0b1f3a]">
          They fail because they lack structure.
        </p>
        <p>
          Levanta exists to turn growth into a system. To replace randomness with
          clarity. To make progress measurable. To build an environment where
          discipline becomes natural and consistency becomes normal.
        </p>
      </Chapter>

      {/* Three foundations */}
      <section className="px-6 py-20 md:py-24 bg-gradient-to-b from-[#eaf3fb] to-white">
        <div className="max-w-5xl mx-auto text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-blue-600 mb-5">
            It stands on three foundations
          </p>
          {(() => {
            const foundations = [
              { word: 'Discipline.', tail: 'Showing up when motivation is gone.' },
              { word: 'Structure.', tail: 'A system you can return to, every day.' },
              { word: 'Community.', tail: 'People who hold the same standard you do.' },
            ];
            return (
              <>
                <div className="hidden md:grid md:grid-cols-3 gap-5 mt-10">
                  {foundations.map((p) => (
                    <div
                      key={p.word}
                      className="rounded-3xl bg-white ring-1 ring-black/5 shadow-sm p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
                    >
                      <p className="text-3xl md:text-4xl font-black text-[#0b1f3a] mb-3">
                        <em className="italic font-light text-blue-600">{p.word}</em>
                      </p>
                      <p className="text-[#0b1f3a]/70 leading-relaxed">{p.tail}</p>
                    </div>
                  ))}
                </div>
                <div
                  className="md:hidden mt-8 -mx-6 px-6 flex gap-4 overflow-x-auto snap-x snap-mandatory pb-3 text-left"
                  style={{ scrollbarWidth: 'none' }}
                  data-testid="founder-foundations-mobile"
                >
                  {foundations.map((p) => (
                    <div
                      key={p.word}
                      className="shrink-0 w-[80vw] max-w-[320px] snap-start rounded-3xl bg-white ring-1 ring-black/5 shadow-sm p-6"
                    >
                      <p className="text-2xl font-black text-[#0b1f3a] mb-2">
                        <em className="italic font-light text-blue-600">{p.word}</em>
                      </p>
                      <p className="text-[#0b1f3a]/70 leading-relaxed text-sm">{p.tail}</p>
                    </div>
                  ))}
                </div>
                <style>{`[data-testid="founder-foundations-mobile"]::-webkit-scrollbar{display:none;}`}</style>
                <p className="md:hidden mt-3 text-center text-xs text-[#0b1f3a]/45 tracking-wider uppercase">
                  Swipe → to explore
                </p>
              </>
            );
          })()}
        </div>
      </section>

      {/* Closing — the earned ending. Mobile sizes downscaled so the
          three-line stanza doesn't blow up across the entire phone
          screen. Desktop keeps the original cinematic scale. */}
      <section className="px-6 py-16 md:py-28 bg-white">
        <div className="max-w-3xl mx-auto text-center space-y-4 md:space-y-5 text-base md:text-2xl text-[#0b1f3a]/80 leading-relaxed">
          <p>I built Levanta not from having it all figured out.</p>
          <p>From falling, adjusting, and trying again.</p>
          <p className="font-bold text-[#0b1f3a] text-lg md:text-3xl pt-3 md:pt-4">
            From discovering that change is not accidental —
          </p>
          <p className="text-2xl md:text-5xl font-black tracking-tight text-[#0b1f3a] pt-1 md:pt-2 leading-tight">
            It is <em className="italic font-light text-blue-600">learned.</em>{' '}
            And it is <em className="italic font-light text-blue-600">earned.</em>
          </p>
        </div>
      </section>

      {/* CTA band — same dark navy CTA as homepage / FAQ / Story. */}
      <section className="px-6 py-24 md:py-28 bg-[#0b1f3a]">
        <div className="max-w-3xl mx-auto text-center text-white">
          <h2 className="text-4xl md:text-5xl font-black leading-tight">
            Ready to{' '}
            <em className="italic font-light text-blue-300">do the work?</em>
          </h2>
          <p className="mt-6 text-lg md:text-xl text-white/75">
            Open the app. Growth is not accidental. It is built.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <Link
              to="/download-app"
              data-testid="founder-cta-download"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-white text-[#0b1f3a] font-semibold shadow-md hover:shadow-2xl hover:-translate-y-0.5 transition-all duration-200"
            >
              Download Levanta
              <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to="/levanta-story"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-white/5 text-white font-semibold ring-1 ring-white/20 hover:bg-white/10 transition-all duration-200"
            >
              Read Levanta&rsquo;s story
            </Link>
          </div>
        </div>
      </section>

      <AltFooter />
    </div>
  );
};

export default Founder;
